import moment, { Moment } from 'moment';
import { TextCell } from './TextCell';

type DateCellProps = {
  fallback?: React.ReactNode;
  value?: string | Date | Moment;
  format?: string;
  className?: string;
};

export const DateCell: React.FC<DateCellProps> = (props) => {
  const { value, className, format = 'DD/MM/YYYY', fallback = '/' } = props;

  const renderContent = () => {
    if (moment.isMoment(value)) {
      return value.format(format);
    }
    const dateValue = moment(value);
    if (dateValue.isValid()) {
      return dateValue.format(format);
    }
    return fallback;
  };
  return (
    <TextCell className={className} fallback={fallback}>
      {renderContent()}
    </TextCell>
  );
};
